import { render } from "./UserProfile.vue?vue&type=template&id=448e3194"
const script = {}

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__